<template>
    <v-layout column>
        <!-- <div class="title">Devices</div>  -->
        <span class="title text-xs-left text-sm-left text-md-center text-lg-center mb-2 mt-4">Assigned Students</span>
        <v-divider class="grey"></v-divider>
        <br>
        <v-dialog v-model="deleteDialog" max-width="550" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    Remove Student?
                </v-card-title>
                <v-card-text class="text-xs-left">
                    Are you sure you want to remove this student from admin ?
                </v-card-text>
                <v-card-actions>
                    <v-flex layout row wrap>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="error" block dark flat="flat" @click="deleteDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="primary" block dark flat="flat" @click="removeVehicle()">Confirm</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="uploadDialog" max-width="350" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    Upload Excel File
                </v-card-title>
                <v-card-text class="text-xs-left">
                    <v-text-field prepend-icon="attach_file" id="file" single-line @click="getFile()" v-model="file" label="Upload File" required  ref="fileTextField" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"></v-text-field>
                    <v-text-field v-model="file" type="file" id="get_file" class="get_file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-flex layout row wrap>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="error" block dark flat="flat" @click="uploadDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="primary" block dark flat="flat" @click="upload()">Submit</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="methodDialog" max-width="550" persistent>
            <v-card>
                <v-card-title class="grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    <span class="subheading">Select a Method</span>
                    <v-btn class="close" icon right flat="flat" @click="methodDialog = false"><v-icon small >close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="text-xs-center">
                    Please select a device creation method:
                </v-card-text>
                <v-card-actions>
                    <v-flex layout row wrap>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="primary" block dark flat="flat" @click="openExistingDialog()" ><v-icon x-large class="pr-3">keyboard</v-icon>Existing Vehicle</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="primary" block dark flat="flat" @click="openNewDialog()"><v-icon  x-large class="pr-3">cloud_upload</v-icon>New Vehicle</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="newVehicleDialog" max-width="850" persistent>
            <v-card>
                <v-card-title class="grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    <span class="subheading"> Add Student </span>
                    <v-btn class="close" icon right flat="flat" @click="newVehicleDialog = false"><v-icon small >close</v-icon></v-btn>
                </v-card-title>
                <!--<v-card-text class="text-xs-center">-->
                <!--Please select a sim card from the list:-->
                <!--</v-card-text>-->
                <!--<v-flex layout row wrap pt-2 pb-2>-->
                    <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                        <!--<v-text-field-->
                                <!--v-model="form.description"-->
                                <!--type="text"-->
                                <!--name="email"-->
                                <!--label="*Description"-->
                                <!--box-->
                        <!--&gt;</v-text-field>-->
                    <!--</v-flex>-->
                    <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                        <!--<v-text-field-->
                                <!--v-model="form.licence_number"-->
                                <!--type="text"-->
                                <!--name="email"-->
                                <!--label="*Licence Number"-->
                                <!--box-->
                        <!--&gt;</v-text-field>-->
                    <!--</v-flex>-->
                <!--</v-flex>-->

                <v-flex layout row wrap pt-2 pb-2 mb-4 text-xs-left text-sm-left text-md-center text-lg-center>
                    <v-flex xs12 sm6 md4 lg4 pt-6>
                        <!--<v-text-field label="*Vehicle Make" v-model="form.device_version" :rules="[rules.required]" box ></v-text-field>-->
                        <v-autocomplete :items="$store.getters.getAllStudents.sort()" label="Student Email"
                                        item-text="email" item-value="id" placeholder="email"
                                        v-model="form.student_id" box >

                        </v-autocomplete>
                    </v-flex>
                    <!--<v-flex xs12 sm6 md4 lg4 pl-4 pt-6>-->
                        <!--&lt;!&ndash;<v-text-field label="*Vehicle Model" v-model="form.sim_pack" :rules="[rules.required]" box ></v-text-field>&ndash;&gt;-->
                        <!--<v-autocomplete :items="$store.getters.getVehicleModels.sort()" label="*Vehicle Model"-->
                                        <!--item-text="name" item-value="id" :placeholder="form.model"-->
                                        <!--v-model="form.model" :rules="[rules.required]" box >-->

                        <!--</v-autocomplete>-->
                    <!--</v-flex>-->
                    <!--<v-flex xs12 sm6 md3 lg3 pl-1 pr-1 pt-6>-->
                        <!--<v-text-field type="text" v-model="form.year" name="car_year" label="Car Year" box ></v-text-field>-->
                    <!--</v-flex>-->

                    <!--<v-flex xs12 sm6 md3 lg3 pl-1 pr-1 pt-6>-->
                    <!--<v-text-field type="text" v-model="form.colour" name="car_colour" label="Car Colour" box ></v-text-field>-->
                    <!--</v-flex>-->

                </v-flex>
                <!--<v-flex layout row wrap pt-4 mb-4>-->
                    <!--<v-flex xs12 sm6 md3 lg3 pl-1 pr-1 pt-6>-->
                        <!--<v-text-field type="text" v-model="form.colour" name="car_colour" label="Car Colour" box ></v-text-field>-->
                    <!--</v-flex>-->
                <!--</v-flex>-->
                <v-card-actions>
                    <v-flex xs12 layout row wrap>
                        <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                            <v-btn class="error" block dark flat="flat" @click="newVehicleDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                            <v-btn class="primary" block dark flat="flat" v-on:click="submitVehicle()">Ok</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--<v-dialog v-model="existingVehicleDialog" max-width="850" persistent>-->
            <!--<v-card>-->
                <!--<v-card-title class="grey lighten-2">-->
                    <!--&lt;!&ndash; <v-icon medium color="warning">warning</v-icon> &ndash;&gt;-->
                    <!--<span class="subheading"> Existing Vehicle </span>-->
                    <!--<v-btn class="close" icon right flat="flat" @click="existingVehicleDialog = false"><v-icon small >close</v-icon></v-btn>-->
                <!--</v-card-title>-->

                <!--<v-flex xs12 sm10 md10 lg10 pl-2 pt-2 pb-2 mb-4>-->
                    <!--&lt;!&ndash;<v-text-field label="*Vehicle Make" v-model="form.device_version" :rules="[rules.required]" box ></v-text-field>&ndash;&gt;-->
                    <!--<v-autocomplete :items="unassignedVehicles" label="*Vehicle Licence Number"-->
                                    <!--item-text="licence_number" item-value="id" :search-input.sync="vehicleSearchInput"-->
                                    <!--v-model="form.id" @change="vehicleChanged" box >-->
                    <!--</v-autocomplete>-->
                <!--</v-flex>-->


                <!--<v-card-actions>-->
                    <!--<v-flex xs12 layout row wrap>-->
                        <!--<v-flex xs12 sm6 pl-2 pr-2 pb-2>-->
                            <!--<v-btn class="error" block dark flat="flat" @click="existingVehicleDialog = false">Cancel</v-btn>-->
                        <!--</v-flex>-->
                        <!--<v-flex xs12 sm6 pl-2 pr-2 pb-2>-->
                            <!--<v-btn class="primary" block dark flat="flat" v-on:click="submitExistingVehicle()">Ok</v-btn>-->
                        <!--</v-flex>-->
                    <!--</v-flex>-->
                <!--</v-card-actions>-->
            <!--</v-card>-->
        <!--</v-dialog>-->

        <v-card >
            <v-toolbar flat dense class="primary" dark>
                <v-text-field xs6 v-model="searchText" prepend-icon="search" label="Search" color="white" single-line clearable hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-btn  v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="newVehicleDialog = true"><v-icon class="pr-3">add</v-icon>Add Student</v-btn>
                <v-btn color="primary" dark class="mb-2" icon @click="getAll()"><v-icon>refresh</v-icon></v-btn>
                <!--<v-btn v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="uploadDialog = true"><v-icon class="pr-3">cloud_upload</v-icon>Activate Device</v-btn>-->
            </v-toolbar>

            <!--<v-data-table v-if="$store.state.customers.vehicle" :headers="$store.state.customers.vehicle.headers"-->
                          <!--:items="allItems" :loading="loading" :search="searchText" :total-items="total"-->
                          <!--class="elevation-2" :rows-per-page-items="rows" :pagination.sync="pagination">-->
                <!--<v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>-->
                <!--<template slot="headers" slot-scope="props">-->
                    <!--<tr>-->
                        <!--<th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>-->
                    <!--</tr>-->
                <!--</template>-->
                <!--<template slot="items" slot-scope="props">-->
                    <!--<tr @click="highlightDevice = props.item" :class="{'grey lighten-3':highlightDevice == props.item}">-->
                        <!--<td v-for="(header, index) in $store.state.customers.vehicle.headers" :key="index" :class="'text-xs-'+header.align">-->
                            <!--<span v-if="header.value == 'model'">{{ $store.getters.getVehicleModelById(props.item[header.value]) }}</span>-->
                            <!--<span v-else-if="header.value == 'make'">{{ $store.getters.getVehicleMakeById(props.item[header.value])}}</span>-->
                            <!--<span v-else-if="header.value != 'actions'">{{ props.item[header.value] }}</span>-->
                            <!--<span v-else v-show="$store.state.auth.user.role!=4">-->
                                <!--<v-btn icon class="grey lighten-4" @click="edit(props.item)">-->
                                  <!--<v-icon color="primary">edit</v-icon>-->
                                <!--</v-btn>-->
                                 <!--<v-btn v-if="$store.state.auth.user.role=='1' || $store.state.auth.user.role=='2'" icon class="grey lighten-4" @click="deletePrompt(props.item)">-->
                                  <!--<v-icon color="accent">highlight_off</v-icon>-->
                                <!--</v-btn>-->
                          <!--</span>-->
                        <!--</td>-->
                    <!--</tr>-->
                <!--</template>-->
            <!--</v-data-table>-->
            <v-data-table v-if="$store.state.users.users" :rows-per-page-items="rows" :headers="$store.state.users.users.headers"
                          :items="$store.getters.filterStudents" :loading="loading" :search="searchText" class="elevation-2">
                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr @click="highlightDevice = props.item" :class="{'grey lighten-3':highlightDevice == props.item}">
                        <td v-for="(header, index) in $store.state.users.users.headers" :key="index" :class="'text-xs-'+header.align">
                            <span v-if="header.value != 'actions'">{{ props.item[header.value] }}</span>
                            <span v-else v-show="$store.state.auth.user.role==1">
                <!--<v-btn icon class="grey lighten-4" @click="edit(props.item)">-->
                  <!--<v-icon color="primary">edit</v-icon>-->
                <!--</v-btn>-->
                <v-btn icon class="grey lighten-4" @click="deletePrompt(props.item)">
                  <v-icon color="accent">delete</v-icon>
                </v-btn>
              </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </v-layout>
</template>

<script>
    // import CustomerService from "@/services/CustomerService";
    // import VehicleService from "@/services/VehicleService";

    import UserService from "@/services/UserService";

    export default {
        name: "AllAdminStudents",
        components: {},
        data() {
            return {
                unassignedVehicles: null,
                vehicleSearchInput:"",
                existingVehicleDialog: null,
                searchText: null,
                highlightDevice: null,
                loading: false,
                loadingTime: 1000,
                deleteDialog: false,
                selectedDevice: null,
                methodDialog: false,
                uploadDialog: false,
                newVehicleDialog: false,
                file: "",
                rows:[10,20,50,150,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
                allItems:[],
                total: 0,
                pagination: {},
                lastPage: 1,
                form: {
                    // date:null,
                    // id: null,
                    // make: null,
                    // model: null,
                    // year: null,
                    // description: null,
                    // colour: null,
                    // account_id: null,
                    // licence_number: null,
                    // vehicle_id: null,
                    student_id: null,
                    admin_id: null,
                },
                rules: {
                    required: value => !!value || "Required. Here."
                },
            };
        },
        watch: {
            pagination: {
                handler () {
                    if(this.pagination.page == 1 && this.lastPage == 1) {
                        // this.getAll();
                    } else if(this.pagination.page < this.lastPage)  {
                        this.getPrev();
                    } else {
                        this.getMore();
                    }
                },
                deep: true
            },
            async vehicleSearchInput(current, previous){
                try {
                    console.log("vehicleSearchInput", current, " ", previous);
                    var limit = 100;
                    const vehicleResponse = await VehicleService.getAllUnassigned("", "", limit, current || "");
                    console.log("vehicles ", vehicleResponse);
                    // this.$store.dispatch("setCustomerVehicles", vehicleResponse.data.data)
                    this.unassignedVehicles = vehicleResponse.data.data
                }catch (err) {
                    console.log(err);
                }
            },
            async searchText(){
                try {
                    var color = "info";
                    // this.loading=true;
                    // console.log('Search Watch');
                    // console.log(this.searchText);
                    // const response = await CustomerService.getAll("", "", this.pagination.rowsPerPage, this.searchText);
                    // console.log(response);
                    // if (response.data.code > 200) {
                    //     color = "warning";
                    // } else if (response.data.result == 2000) {
                    //     this.$store.dispatch("setBillingReports", response.data.data);
                    //     this.allItems=response.data.data;
                    //     this.total = response.data.total;
                    //     // this.convertDate()
                    // }
                    // this.loading = false;
                    // this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
                } catch (err) {
                    // console.log(err);
                    // this.loading = false;
                    // this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "left", timeout: 3000});
                }
            }
        },
        mounted() {
            this.getAll();
        },
        methods: {
            openExistingDialog: function(){
                this.methodDialog = false;
                this.existingVehicleDialog = true;
            },
            openNewDialog: function(){
                this.methodDialog = false;
                this.newVehicleDialog = true;
            },
            async vehicleChanged(){
                // var color = "info";
                var veh = this.unassignedVehicles.find(veh => veh.id == this.form.vehicle_id);
                // make =
                console.log("vehicle changed to: ", this.form);

                // const accountsResponse = await CustomerService.getAccounts(this.form.customer);
                // console.log("customer accounts: ", accountsResponse.data.data);
                // if (accountsResponse.data.code > 200) {
                //     color = "warning";
                // } else if (accountsResponse.data.result == 2000 && accountsResponse.data.data) {
                //     // this.$store.dispatch("setCustomers", accountsResponse.data.data);
                //     this.customerAccounts = accountsResponse.data.data;
                //     // this.total = customerResponse.data.total;
                //     // this.convertDate()
                // }
                // this.$store.dispatch("setSnackbar", {show: true, text: accountsResponse.data.message, color: color, x: "left", timeout: 2000});
            },
            async submitExistingVehicle(){
                try {
                    var color = "info";
                    // this.convertDate();
                    // console.log(this.form);
                    // const response = await CustomerService.update(this.form);
                    // console.log(response)
                    var account =  JSON.parse(JSON.stringify(this.$store.state.accounts.editAccount));
                    this.form.account_id = account.id;
                    // this.form.id = this.form.vehicle_id;
                    // this.form.vehicle_id = this.currentVehicle.id;
                    // this.form.account_id = this.currentVehicle.account_id;
                    // this.form.prev_dev_id = this.currentVehicle.device_id;
                    console.log("add vehicle: ", this.form);
                    const response = await CustomerService.addVehicle(this.form);
                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000) {
                        color = "success";
                        // this.$router.push({ name: "allJobs" });
                        // this.$router.go(-1)
                        this.vehicleSearchInput = "";
                        this.existingVehicleDialog = false;
                        this.getAll();
                    }
                    this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
                } catch (err) {
                    console.log(err);
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "left", timeout: 3000});
                }
            },
            getPrev() {
                // var start = this.pagination.page * this.pagination.rowsPerPage -1;
                var end = this.pagination.page * this.pagination.rowsPerPage -1;
                // var end = this.pagination.rowsPerPage + start;
                var start = (this.pagination.page * this.pagination.rowsPerPage) - this.pagination.rowsPerPage;
                console.log("current page", this.pagination.page);
                console.log("prev start", start, " prev end", end);
                this.allItems = this.$store.state.devices.devices.records.slice(start, end);
            },
            edit: function(vehicle){
                // this.$store.dispatch('editDevice', JSON.parse(JSON.stringify(device)));
                this.$store.dispatch('editVehicle', JSON.parse(JSON.stringify(vehicle)));
                this.$router.push({name: 'editVehicle'/*, params: {id: device.imei}*/})
            },
            openUploadDialog: function(){
                this.methodDialog = false;
                this.uploadDialog = true;
            },
            deletePrompt: function(device){
                this.selectedDevice = device;
                this.deleteDialog = true;

                console.log("Selected student: ", device);
            },
            async removeVehicle() {
                try {
                    console.log("selected vehicle: ", this.selectedDevice);
                    var color = "info";
                    //   // var device =JSON.stringify(this.selectedDevice)
                    const response = await UserService.deleteAdminStudent(this.selectedDevice.filter_id);
                    console.log(response);
                    if (response.data.code > 200) {
                        this.deleteDialog = false;
                        color = "warning";
                    } else if (response.data.result == 2000) {
                        this.deleteDialog = false;
                        this.getAll();
                        // this.$router.push({name: 'allDevices'})
                    }
                    this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "right", timeout: 3000});
                } catch (err) {
                    console.log(err);
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "right", timeout: 3000});
                }
            },
            async submitVehicle(){
                var color = "info";
                console.log("submitVehicle");
                // var account =  JSON.parse(JSON.stringify(this.$store.state.accounts.editAccount));

                let admin = JSON.parse(JSON.stringify(this.$store.state.users.editUser));
                console.log(admin.id);

                this.form.admin_id = admin.id;
                console.log("add student: ", this.form);
                const response = await UserService.addStudent(this.form);
                console.log("add student response: ", response);

                if (response.data.code > 200) {
                    color = "warning";
                } else if (response.data.result == 2000) {
                    // this.$store.dispatch("setCustomerVehicles", response.data.data);
                    // this.allItems = response.data.data;
                    // this.total = response.data.total
                    // console.log("allitems: ", this.allItems);
                    this.getAll();
                    this.newVehicleDialog = false;
                }

                this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
            },
            async getAll() {
                try {
                    var color = "info";
                    // const vehicleMakeResponse = await CustomerService.getAllMakes();
                    // const vehicleModelResponse = await CustomerService.getAllModels();

                    console.log("User: ", JSON.parse(JSON.stringify(this.$store.state.users.editUser)));
                    let admin = JSON.parse(JSON.stringify(this.$store.state.users.editUser));
                    console.log(admin.id);
                    const adminStudentResponse = await UserService.getAdminStudents(admin.id);
                    // const allStudentResponse = await StudentService.getAll();

                    console.log("student reponse: ", adminStudentResponse);

                    // console.log("All students response: ", allStudentResponse);
                    // this.$store.dispatch("setAllStudents", allStudentResponse.data.data);

                    // console.log("stored students ", this.$store.state.student.records);

                    // const response = await DeviceService.getAll("", "", this.pagination.rowsPerPage, "");
                    var account =  JSON.parse(JSON.stringify(this.$store.state.accounts.editAccount));

                    if (adminStudentResponse.data.code > 200) {
                        color = "warning";
                    } else if (adminStudentResponse.data.result == 2000) {
                        // this.$store.dispatch("setCustomerVehicles", response.data.data);
                        this.$store.dispatch("setAdminStudents", adminStudentResponse.data.data);
                        this.allItems = adminStudentResponse.data.data;
                        // this.total = response.data.total
                        console.log("allitems: ", this.allItems);
                    }
                    this.$store.dispatch("setSnackbar", {show: true, text: adminStudentResponse.data.message, color: color, x: "left", timeout: 3000});
                } catch (err) {
                    console.log(err);
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "left", timeout: 3000});
                }
            },
            async getMore() {
                try {
                    var color = "info";
                    const response = await CustomerService.getAll(this.allItems[this.allItems.length -1].device_id,
                        (new Date(this.allItems[this.allItems.length -1].created_at).getTime() / 1000), this.pagination.rowsPerPage, "");
                    // // console.log(response)
                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000) {
                        // console.log("stored records",this.$store.state.devices.devices.records.length);
                        // this.$store.dispatch("setDevices", this.$store.state.devices.devices.records.concat(response.data.data));
                        // console.log("stored records after set",this.$store.state.devices.devices.records.length);
                        // this.allItems = response.data.data;
                        // this.lastPage++;
                    }
                    this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
                } catch (err) {
                    console.log(err);
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "left", timeout: 3000});
                }
            },
            getFile: function (){
                document.getElementById('get_file').click();
            },
            async upload(){
                try{
                    var color = "info";
                    var formData = new FormData();
                    // this.file=document.getElementById('get_file').files[0];
                    formData.append('file', document.getElementById('get_file').files[0])
                    const response = await CustomerService.upload(formData)
                    // // console.log(response)
                    // if(response.data.code > 403){
                    //     color = "warning"
                    // }else if(response.data.result == 2000){
                    //     this.file= "";
                    // }
                    // this.methodDialog = false;
                    // this.uploadDialog = false;
                    // this.getAll();
                    this.$store.dispatch('setSnackbar', {show: true, text: response.data.message, color: color, x:'right', timeout: 3000})
                }catch(err){
                    console.log(err)
                    this.$store.dispatch('setSnackbar', {show: true, text: "Upload error occured", color: "error", x:'right', timeout: 3000})
                }
            }
        }
    };
</script>

<style scoped>

    /* .meticon {
      font-size: 5em;
      display: inline;
      line-height: 0.2em;
      padding-right: 30%;
    } */

    .v-btn__content {
        color: white !important;
    }

    .close {
        float: right;
        position: absolute;
        margin: 0;
        padding: 0;
    }

    .sub-heading {
        margin: 0 auto;
    }

    .upload{
        text-align:left;
        color:black;
        display:inline;
    }

    .v-text-field{
        padding-left: 5px;
        height: 35px;
    }

    .get_file {
        display: none;
        background-color: aqua;
    }

</style>
